"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyEffectToDamagerEventHandlerActivator = exports.ApplyEffectToDamagerEventHandlerArgs = void 0;
const EventHandlerType_1 = require("../EventHandlerType");
const Registries_1 = require("../../state/Registries");
const EventType_1 = require("../../events/EventType");
class ApplyEffectToDamagerEventHandlerArgs {
    constructor(source, duration, effect) {
        this.source = source;
        this.duration = duration;
        this.effect = effect;
        this.__type = EventHandlerType_1.EventHandlerType.ApplyEffectToDamager;
        this.__typeName = "ApplyEffectToDamager";
    }
}
exports.ApplyEffectToDamagerEventHandlerArgs = ApplyEffectToDamagerEventHandlerArgs;
let ApplyEffectToDamagerEventHandlerActivator = class ApplyEffectToDamagerEventHandlerActivator {
    activate(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.Damaged) {
            return;
        }
        container.applyEffect(sequence, handler.args.source, event.args.damagedBy, handler.args.effect, handler.args.duration);
    }
};
ApplyEffectToDamagerEventHandlerActivator = __decorate([
    Registries_1.EventHandlers.register(EventHandlerType_1.EventHandlerType.ApplyEffectToDamager)
], ApplyEffectToDamagerEventHandlerActivator);
exports.ApplyEffectToDamagerEventHandlerActivator = ApplyEffectToDamagerEventHandlerActivator;
